<template>
    <div class="demo_request_list">
        <div class="demo_request_header">
            <div class="row align-items-center">
                <div class="col-auto ml-auto">
                    <button class="btn btn-primary" @click="authorizedUserDemoForReqStatePopup">Demo Request</button>
                </div>
            </div>
        </div>
        <div class="demo_req_body_box">
            <table class="table" v-if="demoRequestList">
                <thead>
                    <tr>
                        <th class="text-left">Type</th>
                        <th class="text-center">Slot</th>
                        <th class="text-center">Time zone</th>
                        <th class="text-center">Status</th>
                        <th class="text-right">Action</th>
                    </tr>
                </thead>
                <tbody v-if="demoRequestListResults.length > 0">
                    <tr v-for="item in demoRequestListResults" :key="item.id">
                        <td class="text-left" style="text-transform:capitalize;">{{ item.title }}</td>
                        <td class="text-center">{{ item.date | dateformat }} {{ item.user_timeslot }}
                        </td>
                        <td class="text-center">{{ item.user_timezone }}</td>
                        <td class="text-center">
                            <label v-if="item.is_completed" class="badge badge-success">Completed</label>
                            <template v-else>
                                <label v-if="item.status == 'requested'" class="badge badge-primary">Requested</label>
                                <label v-else class="badge badge-success">Confirmed</label>
                            </template>
                        </td>
                        <td class="text-right">
                            <label v-if="item.is_completed" class="badge badge-success">Completed</label>
                            <button class="btn btn-primary update_info_btn" v-else
                                @click="updateRequestInfoMethod(item)" :disabled="isUpdateDisabled(item.date, item.user_timeslot) || item.slot_update_count >= 2">Update</button>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr class="text-center">
                        <td colspan="9" width="100%">You don't have any demo for request</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <authorized-user-for-demo-request v-if="authorizedUserDemoForReqState"></authorized-user-for-demo-request>
        <update-request-popup v-if="updateRequestPopupState" :info="demoInfo"></update-request-popup>
    </div>
</template>

<script>
/*eslint-disable */
import { mapGetters } from 'vuex';
import authorizedUserForDemoRequest from './authorized-user-for-demo-request/index.vue';
import updateRequestPopup from '@/components/private/demoRequests/updateRequestPopup.vue';
import { bus } from '@/main';

export default {
    name: 'demo-request-list',
    components: {
        'authorized-user-for-demo-request': authorizedUserForDemoRequest,
        'update-request-popup': updateRequestPopup
    },
    props: ['userInfo'],
    data() {
        return {
            demoRequestList: null,
            demoRequestListResults: [],
            selfUserId: '',
            authorizedUserDemoForReqState: false,
            updateRequestPopupState: false,
            demoInfo: null
        }
    },
    computed: {
        ...mapGetters([
            'publicBlogListGetters',
        ]),
        getBlogListFun() {
            this.blogListState = this.$store.getters.blogListGetters.data;
            return;
        },
    },
    mounted() {
        if (localStorage.getItem('LoginedUserID')) {
            this.selfUserId = localStorage.getItem('LoginedUserID')
        }
        this.getDemoRequestListMethod();
        bus.$on('authorizedUserDemoForReqStateBus', (data) => {
            this.authorizedUserDemoForReqState = data;
            this.getDemoRequestListMethod();
        });
        bus.$on('updateRequestPopupStateBus', (data) => {
            this.updateRequestPopupState = data;
            this.getDemoRequestListMethod();
        });
    },
    methods: {
        isUpdateDisabled(slotDateString, slotTimeString) {
            const now = new Date();

            const timeString = slotTimeString + ':00';

            const combinedString = `${slotDateString}T${timeString}`;
            const slotDate = new Date(combinedString);
            const oneHour = 1000 * 60 * 60;
            const twentyFourHours = oneHour * 24;
            const diffTime = now.getTime() - slotDate.getTime();
            const absDiffTime = Math.abs(diffTime);

            // console.log('Current Date/Time:', now.toLocaleString());
            // console.log('Slot Date/Time:', slotDate);
            // console.log('Absolute Difference (hours):', absDiffTime / oneHour);
            return absDiffTime <= twentyFourHours;
        },
        updateRequestInfoMethod(data) {
            this.demoInfo = data;
            this.updateRequestPopupState = true;
            document.body.classList.add('body_right_scroll_remove');
        },
        authorizedUserDemoForReqStatePopup() {
            this.authorizedUserDemoForReqState = true;
            document.body.classList.add('body_right_scroll_remove');
        },
        getDemoRequestListMethod() {
            this.$store.dispatch('getDemoRequestListAction').then((res) => {
                this.demoRequestList = res.data.data;
                this.demoRequestListResults = this.demoRequestList.results;
            })
        },
    },
    watch: {
        getBlogListFun() {
            return this.$store.getters.blogListGetters;
        },
    },
}
</script>
<style lang="scss" scoped>
.demo_request_list {
    .main_heading {
        color: #ffffff;
        font-size: 20px;
        text-transform: uppercase;
        font-weight: bold;
        margin: 0px;
        line-height: 1;

        .back_btn {
            vertical-align: middle;
        }
    }

    .btn-primary {
        cursor: pointer;
        position: relative;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        outline: none !important;
        background: rgba(255, 255, 255, 0.12) !important;
        color: #ffffff !important;
        border: none;
        border-radius: 3px;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        font-size: 16px;
        padding: 4px 10px;

        &.update_info_btn {
            padding: 3px 10px;
        }

        &:hover {
            background: #87cefa !important;
            color: #000 !important;
        }

        &.actv_blog {
            background: #87cefa !important;
            color: #000 !important;
        }
    }

    .demo_request_header {
        border-bottom: 1px solid rgba(255, 255, 255, 0.05);
        padding: 10px 15px;
    }

    .blog_title {
        font-size: 20px;
        margin-bottom: 15px;
        line-height: 1.3;
        color: #fffcc4;
        font-weight: normal;
        letter-spacing: 1.8px;
        word-spacing: 2px;

        a {
            color: #fffcc4;
            text-decoration: none;
            font-family: 'the_bold_fontbold';

            &:hover {
                color: #87cefa;
            }
        }
    }

    .demo_req_body_box {
        padding: 15px;
        height: calc(100dvh - 250px);
        overflow-y: auto;
        font-family: 'georgiaregular';

        &::-webkit-scrollbar {
            width: 8px;
            background: #000000;
        }

        &::-webkit-scrollbar-thumb {
            background-color: #232323;
            border-radius: 10px;
        }

        .table {
            margin-bottom: 0;
            letter-spacing: 0.5px;
            color: #ffffff;
            border-collapse: separate;
            border-spacing: 0 3px;

            >thead th {
                border-bottom: 0;
                font-size: 19px;
                padding: 10px 8px;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                text-transform: uppercase;
                border-top: 0px;
                transition: all ease 0.5s;
                -webkit-transition: all ease 0.5s;
                -moz-transition: all ease 0.5s;
                background: rgba(228, 233, 237, .1);
                color: #87cefa;
                word-spacing: 5px;
            }

            >thead .empty_cell th {
                padding: 0px !important;
                background: none !important;
            }

            >tbody tr td {
                color: #ffffff;
                vertical-align: top;
                padding: 20px 8px;
                font-size: 18px;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                transition: all ease 0.5s;
                -webkit-transition: all ease 0.5s;
                -moz-transition: all ease 0.5s;
                border-top: 0px;
                background: rgba(228, 233, 237, .1);

                .badge {
                    font-weight: normal;
                }
            }

            a:hover {
                text-decoration: none;
            }

            .country-flag {
                width: 45px;
                display: inline-block;
                vertical-align: middle;
                margin-right: 5px;
                object-fit: cover;
            }

            .country-flag-name {
                width: calc(100% - 55px);
                display: inline-block;
                vertical-align: middle;
                line-height: 1.2;
            }

            .btn-success.member_user_video_call_btn {
                padding: 5px;
                font-size: 18px;
                border-radius: 3px;
                background: rgba(255, 255, 255, 0.12);
                color: #ffd400;
                border: none;
                margin-right: 0px;
                text-transform: capitalize;
                font-weight: 400;
                letter-spacing: .03em;
                line-height: 1;
                box-shadow: none !important;
                min-width: 36px;
                height: 34px;

                &:disabled {
                    cursor: not-allowed;
                    opacity: .6;

                    path {
                        fill: #689bba;
                    }
                }

                &:hover path,
                &:focus path {
                    fill: #000000;
                }

                &:hover,
                &:focus {
                    background: #87cefa;
                    color: #22292f;
                    border-color: #87cefa;
                }
            }
        }
    }
}
</style>